module.exports = __webpack_public_path__ + "static/img/drive@2x.bc0ea2c4.png";